import * as React from "react"
import type { SVGProps } from "react"
const SvgTemplate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m7.43 9.76 3.72-6.07a1 1 0 0 1 .38-.37 1 1 0 0 1 .95 0q.21.12.37.37l3.73 6.07a1 1 0 0 1 .02 1.03 1 1 0 0 1-.88.5H8.27a1 1 0 0 1-.87-.5 1 1 0 0 1-.13-.5 1 1 0 0 1 .15-.53M17.5 22.29a4.3 4.3 0 0 1-3.19-1.32A4.3 4.3 0 0 1 13 17.8q0-1.88 1.31-3.2a4.3 4.3 0 0 1 3.19-1.3q1.87 0 3.19 1.3C22 15.9 22 16.55 22 17.8q0 1.87-1.31 3.18c-1.31 1.31-1.94 1.32-3.19 1.32M3 20.79v-6q0-.43.29-.72A1 1 0 0 1 4 13.8h6a.97.97 0 0 1 1 1v6q0 .43-.29.7a1 1 0 0 1-.71.3H4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7m14.5-.5q1.05 0 1.78-.73.72-.72.72-1.77c0-1.05-.24-1.3-.72-1.78q-.73-.72-1.78-.72c-1.05 0-1.3.24-1.77.72q-.73.73-.73 1.78c0 1.05.24 1.29.73 1.77q.72.73 1.77.73M5 19.79h4v-4H5zm5.05-10.5h3.9L12 6.14z" />
  </svg>
)
export default SvgTemplate
